import React, { useEffect, useState } from "react";
import { StyleSheet, View } from "react-native";
import { Helmet } from "react-helmet";

import EventHeader from "./Components/Header/EventHeader";
import EventSchedule from "./Components/EventSchedule";
import { EventDirections } from "./Components/Direction";
import EventPhotos from "./Components/EventPhotos";
import EventDescription from "./Components/EventDescription";

import PageLayout from "@/Components/Layouts/Web/PageLayout";
import type { EventOverview } from "@/schemas/events/EventOverview";
import LoadingScreen from "@/screens/Loading/LoadingScreen";
import { getEventById } from "@/screens/Content/Feed/EventsTab/Hooks/data";

type Props = {
  eventId: string;
};

function EventPage({ eventId }: Props): React.JSX.Element {
  const [currentEvent, setCurrentEvent] = useState<EventOverview | null>(null);

  useEffect(() => {
    const fetchEvent = async (id: string): Promise<void> => {
      const fetchedEvent = getEventById(id);
      setCurrentEvent(fetchedEvent);
    };
    fetchEvent(eventId);
  }, [eventId]);

  const styles = StyleSheet.create({
    content: {
      top: 20,
      width: "100%",
      gap: 25,
    },
    section: {
      marginBottom: 20, // Add margin between sections
    },
    twoColumns: {
      flexDirection: "row",
      gap: 20,
    },
    column: {
      flex: 1,
    },
  });

  if (!currentEvent) {
    return <LoadingScreen />;
  }

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{currentEvent.title}</title>
        <meta name="description" content={currentEvent.description} />
      </Helmet>
      <PageLayout>
        <EventHeader event={currentEvent} />
        <View style={styles.content}>
          <View style={styles.section}>
            <EventDescription event={currentEvent} />
          </View>
          <View style={[styles.section, styles.twoColumns]}>
            <View style={styles.column}>
              <EventSchedule schedule={currentEvent.schedule} />
            </View>
            {currentEvent.gallery.images.length > 0 && (
              <View style={styles.column}>
                <EventPhotos event={currentEvent} />
              </View>
            )}
          </View>
          <View style={styles.section}>
            <EventDirections options={currentEvent.transportations} />
          </View>
        </View>
      </PageLayout>
    </>
  );
}

export default EventPage;
